import React from 'react'
import ContactForm from './ContactForm'
import { COMPANY_INFO } from '../data/pagesData'

export default function BottomContactSection() {
  return (
    <section className="bg-[#EEEEEE] py-12 sm:py-16 lg:py-[100px] px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-[1600px] grid grid-cols-1 lg:grid-cols-2 rounded-2xl overflow-hidden shadow-2xl mx-auto">
        
        {/* Left Column (Light Theme) */}
        <div className="bg-white p-8 sm:p-12 lg:p-14 flex flex-col justify-center space-y-6">
          <div className="space-y-2">
            <span className="text-xs font-black tracking-wider uppercase text-[#0d2238]">
              Kør trygt videre med vores hjælp
            </span>
            <h2 className="text-2xl sm:text-3xl font-extrabold uppercase leading-snug tracking-tight text-[#050b14]">
              Kontakt os – vi står klar til at hjælpe dig
            </h2>
          </div>

          {/* Phone / Call Link */}
          <a
            href={`tel:${COMPANY_INFO.phoneRaw}`}
            className="inline-flex items-center gap-3 text-xl sm:text-2xl font-bold text-[#0e68be] hover:opacity-90 transition-opacity"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 fill-current shrink-0" viewBox="0 0 24 24">
              <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.25 1.02l-2.2 2.2z"/>
            </svg>
            <span>{COMPANY_INFO.phone}</span>
          </a>

          {/* Description Body */}
          <p className="text-sm sm:text-base leading-relaxed text-gray-600">
            Har du spørgsmål, brug for et tilbud eller vil du booke tid på værkstedet? Hos os er vi altid klar til at hjælpe dig – uanset om det gælder service, reparation eller gode råd om din bil.
          </p>
        </div>

        {/* Right Column (Dark Theme: Obsidian #0a0a0b) */}
        <div className="bg-[#0a0a0b] p-8 sm:p-12 lg:p-14 flex flex-col justify-center">
          <ContactForm variant="dark" />
        </div>

      </div>
    </section>
  )
}
